import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/800.css';
import { ThemeOptions, lighten } from '@mui/material';

export const colors = {
    blue: '#53A5EA',
    gold: '#C98508',
    green: '#00A739',
    orange: '#FAAD19',
    purple: '#6F52ED',
    red: '#E24636',
};

const colorClasses: any = {};
Object.entries(colors).forEach(([name, value]) => {
    colorClasses[`.text-${name}`] = {
        color: value,
        fontWeight: 700,
    };
});

export const palettes = {
    dark: {
        background: {
            default: '#3C3B3B',
            paper: '#1E1E1E',
        },
    },
    light: {
        text: {
            primary: '#141414',
        },
    },
};

export const theme: ThemeOptions = {
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 992,
            lg: 1200,
            xl: 1536,
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
                variant: 'contained',
            },
            styleOverrides: {
                root: {
                    fontSize: 17,
                    fontWeight: 600,
                    letterSpacing: 0.5,
                    lineHeight: 1,
                    padding: 12,
                    textTransform: 'none',
                    // TODO: Can this be moved to styleOverrides?
                    '&.MuiButton-sizeExtraLarge': {
                        borderRadius: 50,
                        fontSize: 20,
                        fontWeight: 700,
                        padding: '20px 62px',
                        textTransform: 'uppercase',
                        whiteSpace: 'nowrap',
                    },
                },
                sizeLarge: {
                    borderRadius: 50,
                    fontSize: 20,
                    fontWeight: 700,
                    padding: '22px 60px',
                    whiteSpace: 'nowrap',
                    width: 'auto',
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                ...colorClasses,
                '.formula': {
                    fontWeight: 700,
                    whiteSpace: 'nowrap',
                },
                '.game': {
                    display: 'block',
                    '& ~ div': {
                        left: '0 !important',
                        top: '0 !important',
                    },
                },
                hr: {
                    margin: 0,
                },
                ol: {
                    marginY: 0,
                    paddingLeft: 24,
                },
                p: {
                    margin: 0,
                },
                picture: {
                    display: 'block',
                    lineHeight: 0,
                },
                ul: {
                    margin: 0,
                    paddingLeft: 24,
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFF',
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#3F51B5',
                    fontWeight: 500,
                    textDecorationColor: lighten('#3F51B5', 0.7),
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
            },
        },
    },
    palette: {
        ...colors,
        action: {
            disabledBackground: '#D8D8D8',
            disabled: '#979797',
        },
        error: {
            main: '#DE4F3B',
        },
        primary: {
            main: '#F9C132',
            light: '#FFE9BF',
        },
        secondary: {
            main: '#EBECEF',
        },
        success: {
            main: '#00A739',
        },
        warning: {
            main: '#EE9810',
        },
    },
    typography: {
        // Defaults
        body1: {
            fontSize: 18,
            fontWeight: 400,
            lineHeight: 1.444,
            letterSpacing: 0.75,
        },
        fontFamily: 'Montserrat, sans-serif',

        // Montserrat
        montserrat314: {
            fontSize: 14,
            fontWeight: 300,
            lineHeight: 1,
            letterSpacing: 0.75,
        },
        montserrat413: {
            fontSize: 13,
            fontWeight: 400,
            lineHeight: 1.2,
        },
        montserrat414: {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1.2,
        },
        montserrat415: {
            fontSize: 15,
            fontWeight: 400,
            lineHeight: 1.2,
        },
        montserrat418: {
            fontSize: 18,
            fontWeight: 400,
            letterSpacing: 1,
        },
        montserrat514: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 1.43,
        },
        montserrat518: {
            fontSize: 18,
            fontWeight: 500,
            lineHeight: 1.2,
        },
        montserrat524: {
            fontSize: 24,
            fontWeight: 500,
            lineHeight: 1,
        },
        montserrat528: {
            fontSize: 28,
            fontWeight: 500,
            lineHeight: 0.857,
        },
        montserrat529: {
            fontSize: 29,
            fontWeight: 500,
            lineHeight: 1.345,
        },
        montserrat614: {
            fontSize: 14,
            fontWeight: 600,
            lineHeight: 1.345,
        },
        montserrat618: {
            fontSize: 18,
            fontWeight: 600,
            lineHeight: 1.345,
        },
        montserrat620: {
            fontSize: 20,
            fontWeight: 600,
            lineHeight: 1.345,
        },
        montserrat714: {
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1.444,
        },
        montserrat718: {
            fontSize: 18,
            fontWeight: 700,
            lineHeight: 1.444,
        },
        montserrat828: {
            fontSize: 28,
            fontWeight: 800,
        },
        montserrat848: {
            fontSize: 48,
            fontWeight: 800,
            lineHeight: 1,
        },
    },
};
